import React from "react";

import CloseIcon from "../../assets/icons/CloseIcon";

const ThinkPartnerDetail = ({ onClose, partner }) => {
  return (
    <div className="fixed top-0 bottom-0 left-0 right-0 z-40 flex items-center justify-center mx-2">
      <div className="bg-white border text-black z-50 max-w-main w-[90%] h-full max-h-[80vh] sm:max-h-[90vh] sm:w-[80%] md:w-[60%] lg:w-[50%] rounded-lg sm:rounded-3xl px-4 py-4 sm:px-8 sm:py-8 space-y-2 sm:space-y-4 flex flex-col shadow-2xl shadow-black/50">
        <div className="text-right">
          <button onClick={onClose}>
            <CloseIcon className="w-5 h-5 fill-black sm:h-8 sm:w-8" />
          </button>
        </div>
        <div className="flex flex-col items-center justify-center gap-2 pb-10">
          <img
            src={partner.image}
            alt={partner.name}
            className="object-cover w-64 rounded-lg aspect-square"
          />
          <div className="flex flex-col justify-between pt-5">
            <div>
              <p className="text-base font-bold md:text-lg xl:text-xl">
                {partner.name}
              </p>
              <p className="pb-3 text-sm md:text-base xl:text-lg">
                {partner.position}
              </p>
              <p className="max-h-[22vh] sm:max-h-[27vh] lg:max-h-[33vh] overflow-y-auto text-justify text-sm md:text-md xl:text-md lg:text-base">
                {partner.profile}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed top-0 bottom-0 left-0 right-0 bg-white/50 blur-lg" />
    </div>
  );
};

export default ThinkPartnerDetail;
